export default __webpack_public_path__ + "static/media/ColorShiftsPending.14a190ed.svg";